import { useEffect, useState } from 'react';
import { AlertDialog, Button } from '@radix-ui/themes';
import { Capacitor } from '@capacitor/core';
import { incrementPopupValue } from 'helpers/authentication';
import { pushEventWithProperties } from 'helpers/crmUtils';
import Analytics from 'ui/design-base/Analytics';
import Banner from './Banner';
import InterstitialAd from './InterstitialAd';
import TimerButton from './TimerButton';

export const MembershipPopupModal = () => {
  const [open, setOpen] = useState(true);
  useEffect(() => {
    Analytics.sendEvent({
      category: 'TT Club',
      action: 'Popup Membership displayed',
      label: 'Membership Popup Modal',
    });
    pushEventWithProperties('TT - Paywall', {
      type: 'ads-modal',
    });
  }, []);

  return (
    <AlertDialog.Root open={open}>
      <AlertDialog.Content maxWidth='450px'>
        <div className='flex w-full justify-between align-middle'>
          <AlertDialog.Title>Abbonati per eliminare questo banner</AlertDialog.Title>

          <TimerButton
            onClose={() => {
              incrementPopupValue();
              setOpen(false);
            }}
          />
        </div>
        <AlertDialog.Description className='hidden'>Abbonati per eliminare questo banner</AlertDialog.Description>

        <div className='flex w-full flex-1 flex-col flex-wrap items-center justify-center gap-4'>
          <div id='message' className='flex flex-col items-start gap-2 self-stretch'>
            <div className='text-neutral-neutral-12 text-sm font-normal'>
              Al costo di soli 2.99 al mese potrai sostenere il progetto TennisTalker, rimuovere le pubblicità popup e
              accedere a tutte le funzionalità.
            </div>
          </div>
          <div>{Capacitor.isNativePlatform() ? <InterstitialAd /> : <Banner slot='MEMBERSHIP_POPUP' />}</div>

          <Button
            size='3'
            variant='solid'
            className='text-neutral-neutral-11 flex items-center self-stretch hover:cursor-pointer'
          >
            Attiva la membership
          </Button>
        </div>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};
export default MembershipPopupModal;
